import React from "react"
import { ClipLoader } from "react-spinners"

type ClipSpinnerProps = {
    height: string
    width: string
    marginLeft?: string
    color?: string
    size: number
}

const ClipSpinner = (props: ClipSpinnerProps) => {
    const height = props.height || "15px"
    const width = props.width || "15px"
    const marginLeft = props.marginLeft || "0px"
    const color = props.color || "#FFFFFF"
    const size = props.size || 12
    return <div style={Object.assign({
        height: height,
        width: width,
        marginLeft: marginLeft
    })} >
        <ClipLoader
            color={color}
            loading={true}
            size={size}
        />
    </div>
}

export default ClipSpinner


// WEBPACK FOOTER //
// ./src/common/spinner/ClipSpinner.tsx